import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { ModalHeader } from '~/components/Modal/components';
import Modal from '~/components/Modal/Modal';
import { useModalSlotSelectDate } from '~/components/ModalSlotsSelectDateCD/hooks';
import { useGlobal } from '~/hooks/useGlobal';

import { checkoutStore, mainStore } from '~/stores';

import { ModalBody } from '../ModalComponents';

import { BottomSubmit } from './components/BottomSubmit';
import { DatesCarousel } from './components/DatesCarousel';
import { SlotList } from './components/SlotList';
import styles from './ModalSlotsSelectDateV3.module.scss';

const ModalSlotsSelectDateV3 = () => {
  const { t } = useTranslation();
  const { isMobile } = useGlobal();

  const {
    selectedDate,
    selectedSlotId,
    handleSelectSlot,
    handleSplit,
    shouldSplitSlot,
    setSelectedDate,
    onChangeSlotId,
    timeStamps,
    deliverySlots,
    closeModal,
    currentDelivery,
  } = useModalSlotSelectDate();

  const handleCloseModal = () => {
    closeModal();
  };

  if (!currentDelivery) {
    closeModal();
    return null;
  }

  const order = checkoutStore.slotSelectionModalStore.selectedOrder;

  if (!order) {
    return null;
  }

  const priceWithoutDelivery = +mainStore.convertPenceToPounds(
    order.paid_without_delivery,
  );

  return (
    <Modal isShow className={styles.root} onBackdropDismiss={handleCloseModal}>
      <div className={styles.root}>
        <div className={styles.container}>
          <div className={styles.header}>
            <ModalHeader
              variant={isMobile ? 'dark' : 'default'}
              size="S"
              title={t('checkout:setTimeSlot')}
              onClose={!isMobile ? handleCloseModal : undefined}
            />
          </div>
          <ModalBody className={styles.body}>
            <DatesCarousel
              timeStamps={timeStamps}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
            />
            <SlotList
              deliverySlots={deliverySlots}
              selectedDate={selectedDate}
              selectedSlotId={selectedSlotId}
              onSlotSelect={onChangeSlotId}
              priceWithoutDelivery={priceWithoutDelivery}
            />
          </ModalBody>
          <BottomSubmit
            selectedSlotId={selectedSlotId}
            shouldSplitSlot={shouldSplitSlot}
            handleSplit={handleSplit}
            handleSelectSlot={handleSelectSlot}
            handleCloseModal={handleCloseModal}
          />
        </div>
      </div>
    </Modal>
  );
};

export default observer(ModalSlotsSelectDateV3);
